<template>
	<ul class="nav" :class="[seType,setStyle]">
		<li v-for="(nav,index) in data" :class="{active:isActive==index}" @click="changeNav(index)">
			<a :href="nav.href">{{nav.name}}</a>
		</li>
	</ul>
	<!--<div class="tab-content" v-if="btype!='bar'">
		<div class="tab-pane" v-for="(nav,index) in data">
		</div>
	</div>-->
</template>

<script>
	import lib from "../../assets/js/lib.js"
	export default {
		name: 'bsf-nav',
		components: {},
		props: {
			btype: {
				type: [String, Array],
			},
			data: Array,
			jfd: Boolean
		},
		data() {
			return {
				isActive: 0
			}
		},
		methods: {
			openDropd() {
				this.open = !this.open;
			},
			changeNav(i) {
				this.isActive = i;
				//				this.$emit('selected', menu.val)
			}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		computed: {
			seType() {
				return this.btype ? "nav-" + this.btype : ""
			},
			setStyle() {
				return this.jfd ? "nav-justified" : ""
			},
			setHref() {

			},
			formatted() {
				let data = [];
				this.data.forEach(menu => {
					data.push({
						name: menu[this.dname],
						val: menu[this.dval]
					})
				})
				return data
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.nav {
		&-pills,
		&-tabs {
			>li {
				>a {
					.unbdr;
					color: @cc2;
					cursor: pointer;
					border-radius: 0;
				}
			}
		}
		&-tabs {
			>li {
				>a {
					.bdrt(@w: 2px, @cr: transparent)!important;
					.trs;
				}
				&.active {
					>a {
						.bdrt(@w: 2px, @cr: @ces)!important;
					}
				}
			}
		}
		&-pills {
			li {
				a {}
				&.active {
					a {
						background-color: @ces ;
					}
				}
			}
		}
	}
	
	@media (min-width: 768px) {
		.nav {
			&-tabs.nav-justified {
				>li {
					>a {
						.unbdr;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// nav.vue?59fd7acf